import FullLayout from '../FullLayout/FullLayout';
import LoginLayout from '../pages/login/LoginLayout';
import Login from '../pages/login/Login';
import Error from '../pages/not-found/Error';
import MapPage from '../pages/MapPage/MapPage';
import PalletStatus from '../pages/PalletStatus/PalletStatus';
import ProductionLine from '../pages/productionLine/ProductionLine';
import PalletIdProduction from '../pages/PalletIdProduction/PalletIdProduction';
import PalletIdStore from '../pages/PalletIdStore/PalletIdStore';
import Products from '../pages/Products/Products';
import UserManagement from '../pages/UserManagement/UserManagement';
import SeriesHistory from '../pages/seriesHistory/SeriesHistory';

import PrintPallet from '../pages/PrintPallet/PrintPallet';
import Batch from '../pages/Batch/Batch';
import PalletRebuild from '../pages/PalletRebuild/PalletRebuild';
import Notification from '../pages/Notification/Notification';
import Faq from '../pages/Faq/Faq';
import BatchHistory from "../pages/BatchHistory/BatchHistory";
import PrintQueue from "../pages/printQueue/PrintQueue";
import Order from "../pages/order/Order";
import OrderEditCreate from "../pages/order/OrderEditCreate";
import Transaction from "../pages/transaction/Transaction";
import ReportProductSeries from "../pages/report/ReportProductSeries";
import ReportPalletEntry from "../pages/report/ReportPalletEntry";
import ReportOldInventory from "../pages/report/ReportOldInventory";
import ReportBatchHistory from "../pages/report/ReportBatchHistory";
import ReportInventory from "../pages/report/ReportInventory";

/*****Stores access******/
const ThemeRoutes = [{
    path: '/', element: <FullLayout/>, children: [


        {path: '', index: true, element: <MapPage/>},
        {path: '/PalletStatus', index: true, element: <PalletStatus/>},
        {path: '/productionLine', index: true, element: <ProductionLine/>},
        {path: '/PalletIdProduction', index: true, element: <PalletIdProduction/>},
        {path: '/PalletIdStore', index: true, element: <PalletIdStore/>},
        {path: '/printQueue', index: true, element: <PrintQueue/>},
        {path: '/ProductManagement', index: true, element: <Products/>},
        {path: '/UserManagement', index: true, element: <UserManagement/>},
        {path: '/seriesHistory', index: true, element: <SeriesHistory/>},
        {path: '/Batch', index: true, element: <Batch/>},
        {path: '/BatchHistory', index: true, element: <BatchHistory/>},
        {path: '/PrintPallet', index: true, element: <PrintPallet/>},
        {path: '/PalletRebuild', index: true, element: <PalletRebuild/>},
        {path: '/faq', index: true, element: <Faq/>},
        {path: '/Notification', index: true, element: <Notification/>},
        {path: '/order', index: true, element: <Order/>},
        {path: '/order/create', index: true, element: <OrderEditCreate create/>},
        {path: '/order/edit/:id', index: true, element: <OrderEditCreate edit/>},
        {path: '/order/:id', index: true, element: <OrderEditCreate show/>},
        {path: '/transaction/:id', index: true, element: <Transaction/>},


        {path: '/report/batchHistory', index: true, element: <ReportBatchHistory/>},
        {path: '/report/inventory', index: true, element: <ReportInventory/>},
        {path: '/report/oldInventory', index: true, element: <ReportOldInventory/>},
        {path: '/report/palletEntry', index: true, element: <ReportPalletEntry/>},
        {path: '/report/productSeries', index: true, element: <ReportProductSeries/>},

    ]

}, {
    path: '/login',
    element: <LoginLayout/>,
    children: [
        {path: '/login', element: <Login/>},
    ]
}, {path: '*', element: <Error/>},];

export default ThemeRoutes;
